export default "__VITE_ASSET__BTHXWpmv__"